import { Card, FormControlLabel, Switch } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";

import FormField from "@/components/atoms/FormField";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { ListPriceFormData } from "@/components/screens/ListPriceFormPage/types";
import { ListPriceFormMessages } from "@/messages/listPrice/list-price-form.messages";

type Props = {
  messages: ListPriceFormMessages;
};

function DetailsSection({ messages }: Props) {
  const { values } = useFormikContext<ListPriceFormData>();

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox p={3}>
        <MDBox display="flex" justifyContent="space-between">
          <MDTypography variant="h5" fontWeight={"bold"}>
            {messages.informationGroupTitle}
          </MDTypography>

          <FormControlLabel
            label={messages.kitLabel}
            control={<Switch name="kit" checked={!!values?.kit} disabled />}
          />
        </MDBox>

        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <FormField
                variant="standard"
                name="title"
                label={messages.titleLabel}
                value={values?.title}
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <FormField
                name="code"
                variant="standard"
                label={messages.codeLabel}
                value={values?.code}
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <FormField
                variant="standard"
                name="ean"
                label={messages.eanLabel}
                value={values?.ean}
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <FormField
                variant="standard"
                name="stock"
                label={messages.stockLabel}
                value={values?.stock}
                type="number"
                inputProps={{ min: "0" }}
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 3 }}>
              <FormControlLabel
                label={messages.activeLabel}
                control={<Switch name="active" checked={!!values?.active} disabled />}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default DetailsSection;
